import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { RootState } from '@/redux/store';
import {
  CLSTAG,
  CockpitMode,
  PermissionButton,
  VehicleBusinessType,
} from '@/utils/constant';
import path from '@/assets/img/common/path.png';
import { getPermissionById, transformLocationWgs84togcj02 } from '@/utils';
import { useNavigate } from 'react-router-dom';
import PopModal from '@/components/PopModal';
import SimpleMap from '@/views/ShadowSystem/components/SimpleMap';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import AttentionIcon from '@/components/AttentionIcon';
import { clstagStr } from '@/utils/util';

const Site = ({ vehicleName }: { vehicleName: string }) => {
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo
  );
  const { cockpitMode } = useSelector((state: any) => state.cockpitInfo);
  const { vehicleRealTimeInfo, vehicleBasicInfoNew, alarmEventList } =
    singleVehiclePageInfo;
  const [vehicleStatus, setVehicleStatus] = useState<any>();
  const [sitePop, setSitePop] = useState(false);
  const [popVisible, setPopVisible] = useState(false);
  const [encryption, setEncryption] = useState(true);
  const [staionAndVehicleInfo, setStaionAndVehicleInfo] = useState<any>(null);
  const moreInfoBtnRef = useRef<any>(null);
  const stationBtnPopDom = useRef<any>(null);
  useEffect(() => {
    let status = {};
    if (alarmEventList?.length > 0) {
      status = { color: 'alarm', lable: '异常' };
    } else if (vehicleRealTimeInfo.systemState === 'CONNECTION_LOST') {
      status = { color: 'lost', lable: '失联' };
    } else if (
      ['UNKNOWN', 'OFFLINE'].includes(vehicleRealTimeInfo.systemState)
    ) {
      status = { color: 'offline', lable: '离线' };
    } else if (
      ['NORMAL', 'SELF_REPAIR', 'MALFUNCTION'].includes(
        vehicleRealTimeInfo.systemState
      )
    ) {
      status = { color: 'normal', lable: '正常' };
    }
    setVehicleStatus({ ...status });
  }, [vehicleRealTimeInfo]);

  const crossClick = (type: boolean) => {
    setSitePop(type);
  };
  const encryptionClick = (e: any) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setEncryption(!encryption);
  };

  const encryptionName = () => {
    const siteName = vehicleBasicInfoNew?.stationInfo?.stationUser;
    const encryptionName = encryption
      ? siteName &&
        siteName.replace(siteName.substring(1, siteName.length), '****')
      : siteName;
    return encryptionName || '--';
  };

  const encryptionPhone = () => {
    const phone = vehicleBasicInfoNew?.stationInfo?.stationUserPhone;
    const encryptReg = new RegExp('(\\d{3})\\d*(\\d{4})');
    const encrypPhone = encryption
      ? phone && phone.replace(encryptReg, '$1****$2')
      : phone;
    return encrypPhone || '--';
  };

  const controlPermission = getPermissionById(
    PermissionButton.VEHILCE_BASIC_INFO_DETAIL
  );

  /**
   * 全量获取车辆路径和位置
   */
  const fetchStationAndVehicleLonLat = () => {
    request({
      path: `/monitor/web/map/vehicle/list`,
      method: 'POST',
      body: {
        vehicleName: [vehicleName],
      },
    }).then((res: HTTPResponse) => {
      if (res.code === HttpStatusCode.Success && res.data) {
        setStaionAndVehicleInfo(res.data);
        setPopVisible(true);
      }
    });
  };

  return (
    <div className="station">
      <div className="station-con">
        <div className="header-box fbox jbox cwbox">
          <div className="right-info fbox cwbox">
            <img className="path-img" src={path}></img>
            <span className="license font-JDZhengHT">
              {vehicleName}
              {vehicleBasicInfoNew?.vehicleNumber && (
                <span className="vehicle-number">
                  {vehicleBasicInfoNew.vehicleNumber}
                </span>
              )}
              {cockpitMode === CockpitMode.MONITOR && (
                <AttentionIcon
                  vehicleName={
                    vehicleBasicInfoNew ? [vehicleBasicInfoNew.vehicleName] : []
                  }
                  attentionState={
                    vehicleBasicInfoNew &&
                    vehicleBasicInfoNew.vehicleAttentionState
                      ? vehicleBasicInfoNew.vehicleAttentionState
                      : false
                  }
                  addAttentionClstag={CLSTAG.SinglePage_AddAttention}
                  removeAttentionClstag={CLSTAG.SinglePage_RemoveAttention}
                />
              )}
            </span>
            <span className="vehicle-type">
              {vehicleBasicInfoNew &&
              vehicleBasicInfoNew.businessType === VehicleBusinessType.VENDING
                ? '售卖'
                : '配送'}
            </span>
            {vehicleRealTimeInfo.isSpeedLimitEnabled && (
              <span className="vehicle-limit-icon">限速</span>
            )}
            {vehicleBasicInfoNew &&
              vehicleBasicInfoNew.isUnderRequire === true && (
                <span className="vehicle-limit-icon">维修</span>
              )}
          </div>
          <div className="left-info">
            <span
              className={`vehicle-status ${
                vehicleStatus && vehicleStatus.color
              }`}
            >
              {vehicleStatus && vehicleStatus.lable}
            </span>
          </div>
        </div>
        <div>
          <Row>
            <Col span={5} className="label">
              城市
            </Col>
            <Col span={17} className="value">
              {(vehicleBasicInfoNew && vehicleBasicInfoNew.cityName) || '--'}
            </Col>
          </Row>
          <Row>
            <Col span={5} className="label">
              站点
            </Col>
            <Col span={17} className="value">
              <i className="station-name">
                {vehicleBasicInfoNew?.stationName ?? '--'}
              </i>
              <i
                className="more-btn"
                ref={moreInfoBtnRef}
                onClick={() => {
                  fetchStationAndVehicleLonLat();
                }}
                clstag={clstagStr(CLSTAG.SinglePage_StationDetail)}
              ></i>
            </Col>
          </Row>
        </div>
        <PopModal
          visible={sitePop}
          hasClose={true}
          handleClose={(visible) => {
            crossClick(!visible);
            setEncryption(true);
          }}
          targetRef={stationBtnPopDom}
          popStyle={{
            right: '103%',
            top: '33px',
          }}
          arrowStyle={{
            right: '-6px',
            bottom: '60px',
          }}
        >
          <div className="station-pop-content">
            <div className="field-item">
              <div className="field-label">车型名称</div>
              <div className="field-text">
                {vehicleBasicInfoNew?.vehicleTypeName ?? '--'}
              </div>
            </div>
            <div className="field-item">
              <div className="field-label">软件版本号</div>
              <div className="field-text">
                {vehicleBasicInfoNew?.vehicleVersion ?? '--'}
              </div>
            </div>
            <div className="field-item">
              <div className="field-label">安卓版本号</div>
              <div className="field-text">
                {vehicleBasicInfoNew?.androidVersion ?? '--'}
              </div>
            </div>
            <div className="field-item">
              <div className="field-label">地图版本号</div>
              <div className="field-text">
                {vehicleBasicInfoNew?.mapVersion ?? '--'}
              </div>
            </div>
            <div className="field-item">
              <div className="field-label">视频版本号</div>
              <div className="field-text">
                {vehicleBasicInfoNew?.videoVersion ?? '--'}
              </div>
            </div>
            <div className="field-item">
              <div className="field-label">conf版本号</div>
              <div className="field-text">
                {vehicleBasicInfoNew?.confVersion || '--'}
              </div>
            </div>
          </div>
        </PopModal>
        <PopModal
          title={vehicleBasicInfoNew?.stationName}
          visible={popVisible}
          hasClose={true}
          handleClose={(visible) => {
            setPopVisible(!visible);
            setEncryption(true);
          }}
          targetRef={moreInfoBtnRef}
          popStyle={{
            right: '103%',
            top: '33px',
          }}
          arrowStyle={{
            right: '-6px',
            top: '60px',
          }}
        >
          <div className="station-info-pop">
            <div className="station-info_field">
              <i className="station-user">站点负责人：{encryptionName()}</i>
              <i className="user-phone">{encryptionPhone()}</i>
              <span
                className="encryption"
                onClick={(e: any) => encryptionClick(e)}
              >
                {encryption ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </span>
              <i className="station-usecase">
                站点用途：
                {vehicleBasicInfoNew?.stationInfo?.stationUseCase || '--'}
              </i>
            </div>
            <div className="station-info_field">
              详细地址：
              {vehicleBasicInfoNew?.stationInfo?.stationAddress || '--'}
            </div>
            <div className="map-wrapper">
              <SimpleMap
                width="100%"
                height="381px"
                centerPoint={{
                  lon: staionAndVehicleInfo?.station?.lon,
                  lat: staionAndVehicleInfo?.station?.lat,
                  name: staionAndVehicleInfo?.station?.name,
                }}
                lon={
                  staionAndVehicleInfo?.vehicle &&
                  staionAndVehicleInfo.vehicle[vehicleName]?.lon
                }
                lat={
                  staionAndVehicleInfo?.vehicle &&
                  staionAndVehicleInfo.vehicle[vehicleName]?.lat
                }
                name={
                  staionAndVehicleInfo?.vehicle &&
                  staionAndVehicleInfo.vehicle[vehicleName]?.name
                }
              />
            </div>
          </div>
        </PopModal>
        <div ref={stationBtnPopDom} className="fbox foot-box">
          {controlPermission && (
            <span
              className={`site-more-info ${
                sitePop ? 'site-more-info-active' : ''
              }`}
              onClick={() => {
                crossClick(true);
              }}
            >
              {sitePop ? <LeftOutlined /> : <RightOutlined />}车辆详情
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
export default Site;
